import AuthHeader from "@/features/auth/components/AuthHeader"
import { useCreateEvent } from "@/features/events/hooks/useCreateEvent"
import { EventType } from "@/features/events/types/EventType"
import AuthPageLayout from "@/features/platform-layout/components/AuthPageLayout"
import { LoadingOverlay } from "@/features/shared/components/Loaders"
import { useEffect } from "react"
import { useLogin } from "../hooks/useLogin"
import ChangePasswordDialog from "./ChangePasswordDialog"
import LoginBox from "./LoginBox"

const LoginPage = () => {

    const {
        isLoading,
        passwordErrorText,
        showChangePasswordDialog,
        setShowChangePasswordDialog,
        handleLoginInputsSubmit,
        onBackButtonClick,
        onCreateAccountClick,
    } = useLogin()
    const { sendEvent } = useCreateEvent()

    useEffect(() => {
        void sendEvent({
            event: EventType.PAGE_VIEW,
            sub_category: "login_page",
        })
    }, [])

    // ******************************************************************************************************************

    return (
        <AuthPageLayout>
            <AuthHeader
                onBackClick={onBackButtonClick}
                actionButtonLabel="Crea un account"
                onActionButtonClick={onCreateAccountClick}
            />
            <div className="w-full flex-1 flex flex-col items-center justify-center mt-[80px] overflow-hidden ">
                <div className="w-full sm:w-[328px] md:w-[400px] lg:w-[500px] p-5 bg-white">
                    <LoginBox
                        onSubmit={handleLoginInputsSubmit}
                        passwordError={passwordErrorText}
                    />
                </div>
            </div>
            {
                isLoading && <LoadingOverlay />
            }
            {
                showChangePasswordDialog && <ChangePasswordDialog onClick={() => setShowChangePasswordDialog(!showChangePasswordDialog)} />
            }
        </AuthPageLayout>
    )
}

export default LoginPage
